import { render, staticRenderFns } from "./talent_acquisition.vue?vue&type=template&id=2463b4fa&scoped=true"
import script from "./talent_acquisition.vue?vue&type=script&lang=js"
export * from "./talent_acquisition.vue?vue&type=script&lang=js"
import style0 from "./talent_acquisition.vue?vue&type=style&index=0&id=2463b4fa&prod&scoped=true&lang=less"
import style1 from "./talent_acquisition.vue?vue&type=style&index=1&id=2463b4fa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2463b4fa",
  null
  
)

export default component.exports